import { HttpErrorResponse } from "@angular/common/http";

export class ErrorHelper {

    public static GetClientError(err: any) : string {
        let userFriendlyMessage = 'Error inesperado';

        if (err instanceof HttpErrorResponse) {

          let httpError = err as HttpErrorResponse;
          let errorTitle = httpError.error;
          if (errorTitle.title !== undefined) {
            userFriendlyMessage = errorTitle.title;
          }

          console.log('HttpErrorResponse');
          console.log(httpError);

        }
        else {
            console.log('Error inesperado');
            console.log(err);
        }

        return userFriendlyMessage;

    }

}
